import React, { useState } from 'react';
import { ChakraProvider, Flex, Box } from '@chakra-ui/react';
import Layout from './components/Layout';
import InputCNFForm from './components/InputCNFForm';
import DPLLVisualization from './components/DPLLVisualization';
import theme from './theme';
import './index.css';

function App() {
  const [dpllSteps, setDpllSteps] = useState([]);
  const [dpllTreeData, setDpllTreeData] = useState(null);
  const [isSat, setIsSat] = useState(null);

  const handleSolve = (steps, satResult, treeData) => {
    setDpllSteps(steps);
    setIsSat(satResult);
    setDpllTreeData(treeData);
  };

  return (
    <ChakraProvider theme={theme}>
      <Layout>
        <Flex direction={{ base: 'column', md: 'row' }} gap={4} p={4} flexWrap="wrap">
          <Box flex="1" minW={{ base: '100%', md: '300px' }}>
            <InputCNFForm onSolve={handleSolve} />
          </Box>
          <Box flex="2" minW={{ base: '100%', md: '600px' }}>
            <DPLLVisualization steps={dpllSteps} isSat={isSat} treeData={dpllTreeData} />
          </Box>
        </Flex>
      </Layout>
    </ChakraProvider>
  );
}

export default App;
